import { render, staticRenderFns } from "./AutomationWizardFieldAmount.vue?vue&type=template&id=89c4220a&scoped=true&"
import script from "./AutomationWizardFieldAmount.vue?vue&type=script&lang=js&"
export * from "./AutomationWizardFieldAmount.vue?vue&type=script&lang=js&"
import style0 from "./AutomationWizardFieldAmount.vue?vue&type=style&index=0&id=89c4220a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c4220a",
  null
  
)

export default component.exports